"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackProvider = FeedbackProvider;
var _react = _interopRequireWildcard(require("react"));
var _FeedbackContext = require("./FeedbackContext");
var _Snackbars = require("../components/Snackbars");
var _CustomBackdrop = require("../components/CustomBackdrop");
var _api = require("@focaltec-suite/api");
var _FeedbackErrorPopup = _interopRequireDefault(require("./FeedbackErrorPopup"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function FeedbackProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    info = _useState2[0],
    setInfo = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    success = _useState4[0],
    setSuccess = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    warning = _useState6[0],
    setWarning = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    backdrop = _useState10[0],
    setBackdrop = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    backdropText = _useState12[0],
    setBackdropText = _useState12[1];
  var _useState13 = (0, _react.useState)(),
    _useState14 = _slicedToArray(_useState13, 2),
    customError = _useState14[0],
    setCustomError = _useState14[1];
  var horizontal = (0, _react.useMemo)(function () {
    return 'right';
  }, []);
  var handleError = (0, _react.useCallback)(function (error) {
    if (typeof error === 'string') {
      setError(error);
    } else if (error instanceof _api.CustomError && error.apiError.code < 1000) {
      setCustomError(error);
    } else {
      setError(error.message);
    }
  }, []);
  var closeError = (0, _react.useCallback)(function () {
    setCustomError(undefined);
  }, []);
  var value = (0, _react.useMemo)(function () {
    return {
      showInfo: setInfo,
      showSuccess: setSuccess,
      showWarning: setWarning,
      showError: handleError,
      showBackdrop: function showBackdrop(message) {
        setBackdrop(true);
        setBackdropText(message);
      },
      closeBackdrop: function closeBackdrop() {
        setBackdrop(false);
        setBackdropText(undefined);
      }
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_FeedbackContext.FeedbackContext.Provider, {
    value: value
  }, children, /*#__PURE__*/_react["default"].createElement(_Snackbars.InfoSnackbar, {
    message: info,
    onClose: function onClose() {
      return setInfo(undefined);
    },
    horizontal: horizontal
  }), /*#__PURE__*/_react["default"].createElement(_Snackbars.SuccessSnackbar, {
    message: success,
    onClose: function onClose() {
      return setSuccess(undefined);
    },
    horizontal: horizontal
  }), /*#__PURE__*/_react["default"].createElement(_Snackbars.WarningSnackbar, {
    message: warning,
    onClose: function onClose() {
      return setWarning(undefined);
    },
    horizontal: horizontal
  }), /*#__PURE__*/_react["default"].createElement(_Snackbars.ErrorSnackbar, {
    message: error,
    onClose: function onClose() {
      return setError(undefined);
    },
    horizontal: horizontal
  }), /*#__PURE__*/_react["default"].createElement(_CustomBackdrop.CustomBackdrop, {
    open: backdrop,
    message: backdropText
  }), /*#__PURE__*/_react["default"].createElement(_FeedbackErrorPopup["default"], {
    error: customError,
    onClose: closeError
  }));
}